export const faqDataObject = {
    "categories": [
        {
            "name": "For Couples/Users",
            "faqs": [
                {
                    "question": "What is Wedstra?",
                    "answer": "Wedstra is an online wedding planning marketplace that helps you find and book <strong>verified wedding vendors</strong> across India. From photographers, bridal makeup artists, and decorators to venues and planners, you can discover <strong>everything in one place</strong> along with reviews, portfolios, and prices."
                },
                {
                    "question": "How does Wedstra help me plan my wedding?",
                    "answer": "Wedstra provides tools like a <strong>personalized checklist, budget tracker, and inspiration gallery</strong>, along with access to trusted vendors. You can browse, shortlist, and connect directly with vendors, making wedding planning <strong>stress-free and organized</strong>."
                },
                {
                    "question": "Do I need to pay to use Wedstra?",
                    "answer": "No, creating an account and browsing vendors is <strong>completely free</strong>. We also offer <strong>Popular and Premium plans</strong> that unlock advanced features like direct vendor chat, planning tools, discounts, and a virtual wedding planner."
                },
                {
                    "question": "How do I contact a vendor through Wedstra?",
                    "answer": "Once you create an account, you can view vendor details and either <strong>message them directly</strong> on the platform (if you’re on a paid plan) or <strong>request a callback</strong>. Vendors will reach out to discuss availability, packages, and pricing."
                },
                {
                    "question": "Are the vendors on Wedstra verified?",
                    "answer": "<strong>Yes</strong>. All vendors on Wedstra undergo a <strong>basic verification process</strong> before being listed. We encourage couples to also check reviews, ratings, and past work to make confident decisions."
                },
                {
                    "question": "Can Wedstra help me with destination weddings?",
                    "answer": "<strong>Absolutely!</strong> Wedstra has a wide selection of vendors who <strong>specialize in destination weddings</strong> across India and abroad. You can filter vendors based on location, budget, and style to plan your dream celebration."
                },
                {
                    "question": "Can I get discounts on bookings through Wedstra?",
                    "answer": "<strong>Yes</strong>. Our <strong>Premium Plan members</strong> enjoy exclusive discounts (<strong>15–25%</strong>) from select vendors on Wedstra."
                },
                {
                    "question": "What if I face issues with a vendor I booked?",
                    "answer": "Wedstra provides <strong>customer support to help mediate concerns</strong> between couples and vendors. While final contracts are between you and the vendor, we assist in resolving queries wherever possible."
                }
            ]
        },
        {
            "name": "For Vendors",
            "faqs": [
                {
                    "question": "Why should I list my business on Wedstra?",
                    "answer": "Wedstra connects you directly with couples who are actively planning their weddings. By listing your business, you get <strong>more visibility, direct leads, and potential bookings</strong> without spending on heavy advertising."
                },
                {
                    "question": "Is there a cost to register as a vendor on Wedstra?",
                    "answer": "<strong>Listing your profile is free</strong>. However, vendors can choose <strong>premium placements or advertising options</strong> in the future to reach more couples and boost bookings."
                },
                {
                    "question": "How do I receive inquiries or leads?",
                    "answer": "When couples shortlist or contact your business, you’ll receive a notification in your <strong>vendor dashboard and email</strong>. You can then respond directly through Wedstra to close the booking."
                },
                {
                    "question": "How does Wedstra ensure genuine leads?",
                    "answer": "We <strong>filter spam and verify couple accounts</strong> before passing on inquiries. Our focus is on delivering <strong>quality, genuine leads</strong> that convert into bookings."
                },
                {
                    "question": "Do I need a big marketing budget to work with Wedstra?",
                    "answer": "<strong>Not at all</strong>. Wedstra is built for small, medium, and big vendors alike. Even if you’re just starting out, you can create a profile, showcase your portfolio, and <strong>get discovered by couples</strong> searching in your category."
                },
                {
                    "question": "Can I manage my business profile myself?",
                    "answer": "<strong>Yes</strong>, once registered, you’ll get access to a <strong>vendor dashboard</strong> where you can update photos, prices, and details anytime. Keeping your profile updated increases chances of bookings."
                },
                {
                    "question": "When will I start getting leads after registering?",
                    "answer": "Most vendors begin receiving leads <strong>within the first few weeks</strong> of registering, depending on location, season, and category demand. Active vendors with <strong>complete profiles and good portfolios</strong> get the best results."
                }
            ]
        },
        {
            "name": "General",
            "faqs": [
                {
                    "question": "How is Wedstra different from other wedding platforms?",
                    "answer": "Wedstra is designed to be <strong>simple, transparent, and couple-focused</strong>. Unlike generic directories, we provide <strong>tools, inspiration, and verified vendors</strong> all in one platform, so couples can plan smartly while vendors gain genuine business."
                },
                {
                    "question": "Can I use Wedstra on mobile?",
                    "answer": "<strong>Yes</strong>, Wedstra is available on mobile browsers and will soon be available as an <strong>Android and iOS app</strong>, making planning on the go even easier."
                },
                {
                    "question": "How can I contact Wedstra support?",
                    "answer": "You can reach us anytime via email at <strong><a href='mailto:Wedstra.suport@gmail.com'>Wedstra.suport@gmail.com</a></strong> or through the <strong>Help section</strong> in your profile."
                }
            ]
        }
    ]
};